/**
 * Verlanglijst-indicator (header + mobiel menu) + gedeelde opslag (localStorage + cookie).
 * Teller = unieke product-id's; op de wishlist-pagina worden verweesde id's opgeschoond.
 */
(function () {
  'use strict';

  var KEY = 'user_wishlist';
  var COOKIE_KEY = 'uf_wishlist_mirror';
  var COOKIE_MAX_AGE = 86400 * 400;
  var lastCount = -1;

  function getCookie(name) {
    var m = document.cookie.match(
      new RegExp('(?:^|; )' + name.replace(/[$()*+.?[\\\]^{|}]/g, '\\$&') + '=([^;]*)')
    );
    return m ? decodeURIComponent(m[1]) : '';
  }

  function writeCookie(value) {
    document.cookie =
      COOKIE_KEY +
      '=' +
      encodeURIComponent(value) +
      ';path=/;max-age=' +
      COOKIE_MAX_AGE +
      ';SameSite=Lax';
  }

  function normalizeIds(arr) {
    var seen = {};
    var out = [];
    (arr || []).forEach(function (v) {
      var s = String(v != null ? v : '').trim();
      if (!s || seen[s]) return;
      seen[s] = true;
      out.push(s);
    });
    return out;
  }

  function parseRaw(raw) {
    try {
      var parsed = JSON.parse(String(raw || '[]'));
      return Array.isArray(parsed) ? normalizeIds(parsed) : [];
    } catch (e) {
      return [];
    }
  }

  function readIds() {
    var ls = [];
    try {
      ls = parseRaw(localStorage.getItem(KEY));
    } catch (e) {}
    if (ls.length) return ls;
    return parseRaw(getCookie(COOKIE_KEY));
  }

  function persistIds(ids) {
    var uniq = normalizeIds(ids);
    var s = JSON.stringify(uniq);
    try {
      localStorage.setItem(KEY, s);
    } catch (e) {}
    writeCookie(s);
    return uniq;
  }

  function pruneToVisibleTiles() {
    var grid = document.querySelector('.wishlist-grid');
    if (!grid) return readIds();

    var visible = [];
    grid.querySelectorAll('.wishlist-tile-container[data-product-id]').forEach(function (el) {
      var id = String(el.getAttribute('data-product-id') || '').trim();
      if (id) visible.push(id);
    });

    var stored = readIds();
    var same =
      stored.length === visible.length &&
      stored.every(function (id) {
        return visible.indexOf(id) !== -1;
      });

    if (same) return stored;
    return persistIds(visible);
  }

  function sync() {
    var countEls = document.querySelectorAll('[data-uf-header-wishlist-count]');
    var linkEls = document.querySelectorAll('[data-uf-header-wishlist-link]');
    if (!countEls.length && !linkEls.length) return;

    var n = readIds().length;
    var countChanged = n !== lastCount;
    lastCount = n;

    var label = n === 1 ? '1 item op verlanglijst' : n + ' items op verlanglijst';
    var badgeText = n > 99 ? '99+' : String(n);

    countEls.forEach(function (countEl) {
      countEl.textContent = badgeText;
      if (n > 0) {
        countEl.removeAttribute('hidden');
        countEl.setAttribute('aria-hidden', 'false');
        if (countChanged) countEl.classList.add('is-updated');
        else countEl.classList.remove('is-updated');
      } else {
        countEl.setAttribute('hidden', '');
        countEl.setAttribute('aria-hidden', 'true');
        countEl.classList.remove('is-updated');
      }
    });

    linkEls.forEach(function (linkEl) {
      var outline = linkEl.querySelector('.uf-wishlist-nav-icon__outline');
      var filled = linkEl.querySelector('.uf-wishlist-nav-icon__filled');
      if (n > 0) {
        linkEl.classList.add('is-active');
        linkEl.setAttribute('title', 'Verlanglijst (' + n + ')');
        linkEl.setAttribute('aria-label', 'Verlanglijst, ' + label);
        if (outline) outline.setAttribute('hidden', '');
        if (filled) filled.removeAttribute('hidden');
      } else {
        linkEl.classList.remove('is-active');
        linkEl.setAttribute('title', 'Verlanglijst');
        linkEl.setAttribute('aria-label', 'Verlanglijst');
        if (outline) outline.removeAttribute('hidden');
        if (filled) filled.setAttribute('hidden', '');
      }
    });
  }

  window.ufWishlistReadIds = readIds;
  window.ufWishlistPersistIds = persistIds;
  window.ufWishlistPruneToVisibleTiles = pruneToVisibleTiles;
  window.ufSyncWishlistNavIndicator = sync;
  window.ufNotifyWishlistUpdated = function () {
    try {
      document.dispatchEvent(new CustomEvent('uf-wishlist-updated'));
    } catch (e) {
      sync();
    }
  };

  document.addEventListener('uf-wishlist-updated', sync);
  window.addEventListener('storage', function (e) {
    if (!e || e.key === KEY) sync();
  });
  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) sync();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', sync);
  } else {
    sync();
  }
})();
